export default {
  activeStep: 0,
  data: {
    invoice: {},
    form: {
      inspectionPOReportGroups: [
        {
          criticalAccepted: 0,
          majorAccepted: 2.5,
          minorAccepted: 4.0,
          inspectionReportDefectItems: [],
        },
      ],
      inspectionQuotes: [],
    },
    report: {
      reportFiles: [],
      inspectionReportMaps: [],
      inspectionPOItems: [
        {
          id: 0,
          poNo: '',
          itemName: '',
          itemNo: '',
          orderQty: '',
          cartonsNo: '',
          inspectionDefectItems: [],
        },
      ],
    },
    reportIDs: [],
    invoiceList: {
      loading: false,
      data: {},
      error: null,
    },
    invoiceDownloadedList: {
      loading: false,
      data: {},
      error: null,
    },
    //  ******* New Report *******
    reportList: {
      loading: false,
      data: [],
      error: null,
    },
    reportDetail: {
      loading: false,
      data: {},
      error: null,
    },
    reportDownloadedList: {
      loading: false,
      data: {},
      error: null,
    },
    //  ******* Attachments *******
    attachments: {
      loading: false,
      data: {},
      error: null,
    },
    attachmentsDownloaded: {
      loading: false,
      data: {},
      error: null,
    },
  },
  errors: [],
  status: 'uninitialized',
};
